<template>
  <div :class="$style.changePwd">
    <header>
      <i class="iconfont yw-xiangzuo" @click="$emit('close')" />
      <span>修改密码</span>
      <img
        :src="`${this.$cdnLink}/suspend/tongyong/guanbi.png`"
        alt
        @click="$emit('closePage')"
        :class="$style.closePage"
      />
    </header>
    <div :class="$style.inputWrap">
      <img :src="`${this.$cdnLink}/suspend/mine/lock.png`" alt />
      <input type="text" v-model.trim="form.oldPwd" placeholder="请输入旧密码" />
    </div>
    <div :class="$style.inputWrap">
      <img :src="`${this.$cdnLink}/suspend/mine/lock.png`" />
      <input type="text" v-model.trim="form.newPwd" placeholder="请输入新密码" />
    </div>
    <div :class="$style.inputWrap">
      <img :src="`${this.$cdnLink}/suspend/mine/lock.png`" />
      <input type="text" v-model.trim="form.confirmPwd" placeholder="请再次输入新密码" />
    </div>
    <button :class="$style.submit" @click="submit">确定</button>
  </div>
</template>

<script>
import {
  saveAccount,
  getAccount,
  setStorage
} from "@/libs/utils";
import { mapActions, mapMutations, mapState } from 'vuex';
import { regexpVerify } from "@/libs/business/account";
import { userChangePwd } from '@/api/user';
import CryptoJS from 'crypto-js';

export default {
  name: '',
  data() {
    return {
      form : {
        oldPwd: '',
        newPwd: '',
        confirmPwd: ''
      }
    };
  },
  mounted() {
    this.getCutPswd();
  },
  computed: {
    ...mapState({
      userState: state => state.user
    })
  },
  methods: {
    ...mapActions({
      modifyPwd: 'user/modifyPwd'
    }),
    ...mapMutations({
      changeUserState: 'user/CHANGE_STATE',
      showLoading: 'global/showLoading'
    }),
    getCutPswd() {
      this.list = getAccount() || [];
      this.form.oldPwd = this.list.length ? this.list[0].password : "";
    },
    async submit() {
      await regexpVerify(this.form, [
        { key: "oldPwd", hint: "请输入旧密码" },
        { key: "newPwd", hint: "请输入新密码", type: "password" },
        { key: "confirmPwd", hint: "两次密码不一致", type: "password" },
      ]);
      if (this.form.newPwd !== this.form.confirmPwd) {
        this.$Toast("新密码需要输入一致");
        return;
      }
      const { username, password, user_id, appkey, access_token } = this.userState;
      const { newPwd, oldPwd } = this.form;
      this.showLoading();
      const r = await userChangePwd({
        user_name: username,
        cur_password: CryptoJS.MD5(oldPwd + CryptoJS.MD5(oldPwd)).toString(),
        new_password: CryptoJS.MD5(newPwd + CryptoJS.MD5(newPwd)).toString(),
        user_id: user_id,
        appkey: appkey,
        access_token: access_token
      });
      this.$toast('修改成功');
      this.changeUserState({ password: newPwd });
      setStorage('password', newPwd);
      saveAccount(username, newPwd);
      this.newPwd = '';
      this.confirmPwd = '';
      this.$emit('close');
    }
  }
}
</script>

<style lang="scss" module>
.changePwd {
  background: #ffffff;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  > header {
    position: relative;
    font-size: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: center;
    height: 40px;
    padding: 0 15px;
    color: #7a7979;
    border-bottom: 1px solid #f3f3f3;
    margin-bottom: 40px;
    :global {
      .yw-xiangzuo {
        width: 15px;
        height: 15px;
        color: #7a7979;
      }
    }
    .closePage {
      height: 13px;
    }
  }
  .inputWrap {
    display: flex;
    border-bottom: 1px solid #ebebeb;
    margin: 0 22px 12px;
    padding: 6px 9px;
    > img {
      width: 13px;
      height: 15px;
      margin-right: 14px;
    }
    > input {
      border: none;
      font-size: 15px;
    }
  }
  .submit {
    margin: 54px auto 0;
    width: 293px;
    height: 41px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    font-size: 15px;
    border: none;
    outline: none;
    background: #ff5b58;
    border-radius: 20px;
  }
}
</style>